<template>
<div>
  <div v-if="isDefaultChart">
    <DetailListItem title="Many" asside="All Populus"/>
  </div>
  <div v-else>
    <DetailListItem
      v-if="isOccupation()"
      title="Occupation"
      :figureIndex="querentHouse"
      :asside="`${romanize(querentHouse)} same as ${romanize(quesitedHouse)}`"
    />

    <DetailListItem
      v-if="isConjuctionQuerentToBeforeQuesited()"
      title="Conjunction"
      :figureIndex="querentHouse"
      :asside="`querent moves to ${romanize(quesitedHouse, -1)}`"
    />

    <DetailListItem
      v-if="isConjuctionQuerentToAfterQuesited()"
      title="Conjunction"
      :figureIndex="querentHouse"
      :asside="`querent moves to ${romanize(quesitedHouse, +1)}`"
    />

    <DetailListItem
      v-if="isConjuctionQuesitedToBeforeQuerent()"
      title="Conjunction"
      :figureIndex="quesitedHouse"
      :asside="`quesited moves to ${romanize(querentHouse, -1)}`"
    />

    <DetailListItem
      v-if="isConjuctionQuesitedToAfterQuerent()"
      title="Conjunction"
      :figureIndex="quesitedHouse"
      :asside="`quesited moves to ${romanize(querentHouse, +1)}`"
    />

    <DetailListItem
      v-for="mutation in mutations()"
      v-bind:key="mutation.id"
      title="Mutation"
      :asside="mutation.message"
    />

    <DetailListItem
      v-if="isTranslationBeforeQuerentBeforeQuesited()"
      title="Translation"
      :figureIndex="houseify(querentHouse - 1)"
      :asside="`${romanize(querentHouse - 1)} moves to ${romanize(quesitedHouse - 1)}`"
    />

    <DetailListItem
      v-if="isTranslationBeforeQuerentAfterQuesited()"
      title="Translation"
      :figureIndex="houseify(querentHouse - 1)"
      :asside="`${romanize(querentHouse - 1)} moves to ${romanize(quesitedHouse + 1)}`"
    />

    <DetailListItem
      v-if="isTranslationAfterQuerentBeforeQuesited()"
      title="Translation"
      :figureIndex="houseify(querentHouse + 1)"
      :asside="`${romanize(querentHouse + 1)} moves to ${romanize(quesitedHouse - 1)}`"
    />

    <DetailListItem
      v-if="isTranslationAfterQuerentAfterQuesited()"
      title="Translation"
      :figureIndex="houseify(querentHouse + 1)"
      :asside="`${romanize(querentHouse + 1)} moves to ${romanize(quesitedHouse + 1)}`"
    />

    <DetailListItem
      v-if="denial"
      title="Denial"
      asside="no perfection"
    />
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import DetailListItem from './DetailListItem.vue'
import compare from '../utils/compare'
import Houseify from '../utils/houseify'

const rLookup = {X:10,IX:9,V:5,IV:4,I:1}

const getFigureInHouse = (store, ind) => {
  return store.getters.getFigureById(Number(ind))
}

const getQuerentFigure = (store) => {
  return getFigureInHouse(store, store.state.querentHouse)
}

const getQuesitedFigure = (store) => {
  return getFigureInHouse(store, store.state.quesitedHouse)
}

const isTranslation = (store, querentAdj, quesitedAdj) => {
  const querentHouse = Number(store.state.querentHouse)
  const quesitedHouse = Number(store.state.quesitedHouse)
  const querT = Houseify(Number(querentHouse) + querentAdj)
  const quesT = Houseify(Number(quesitedHouse) + quesitedAdj)

  if (querT === quesT) { return false }
  if (querT === quesitedHouse) { return false }
  if (quesT === querentHouse) { return false }

  const result = compare.sameFigure(
    getFigureInHouse(store, querT),
    getFigureInHouse(store, quesT)
  )
  return result
}

export default {
  name: 'Perfections',
  components: {
    DetailListItem
  },
  data() {
    return {
      occupation: false,
      conjunctionQuerentToBeforeQuesited: false,
      conjunctionQuerentToAfterQuesited: false,
      conjuctionQuesitedToBeforeQuerent: false,
      conjuctionQuesitedToAfterQuerent: false,
      hasMutations: false,
      translationBeforeQuerentBeforeQuesited: false,
      translationBeforeQuerentAfterQuesited: false,
      translationAfterQuerentBeforeQuesited: false,
      translationAfterQuerentAfterQuesited: false,
    }
  },
  computed: {
    ...mapGetters (['isDefaultChart']),
    querentHouse () {
      return Number(this.$store.state.querentHouse)
    },
    quesitedHouse () {
      return Number(this.$store.state.quesitedHouse)
    },
    denial () {
      return this.occupation === false &&
        this.conjunctionQuerentToBeforeQuesited === false &&
        this.conjunctionQuerentToAfterQuesited === false &&
        this.conjuctionQuesitedToBeforeQuerent === false &&
        this.conjuctionQuesitedToAfterQuerent === false &&
        this.hasMutations === false &&
        this.translationBeforeQuerentBeforeQuesited === false &&
        this.translationBeforeQuerentAfterQuesited === false &&
        this.translationAfterQuerentBeforeQuesited === false &&
        this.translationAfterQuerentAfterQuesited === false
    },
  },
  methods: {
    romanize (num, adjust = 0) {
      num = Houseify(Number(num) + adjust)
      let roman = '', i
      for (i in rLookup) {
        while (num >= rLookup[i]) {
          roman += i;
          num -= rLookup[i];
        }
      }
      return roman;
    },
    houseify (num) {
      return Houseify(num)
    },
    isOccupation () {
      const result = compare.sameFigure(
        getQuerentFigure(this.$store),
        getQuesitedFigure(this.$store)
      )
      this.occupation = result
      return result
    },
    isConjuctionQuerentToBeforeQuesited () {
      const result = isTranslation(this.$store, 0, -1)
      this.conjunctionQuerentToBeforeQuesited = result
      return result
    },
    isConjuctionQuerentToAfterQuesited () {
      const result = isTranslation(this.$store, 0, +1)
      this.conjunctionQuerentToAfterQuesited = result
      return result
    },
    isConjuctionQuesitedToBeforeQuerent () {
      const result = isTranslation(this.$store, -1, 0)
      this.conjuctionQuesitedToBeforeQuerent = result
      return result
    },
    isConjuctionQuesitedToAfterQuerent () {
      const result = isTranslation(this.$store, +1, 0)
      this.conjuctionQuesitedToAfterQuerent = result
      return result
    },
    mutations () {
      const mutations = []
      const querentFigure = getQuerentFigure(this.$store)
      const quesitedFigure = getQuesitedFigure(this.$store)

      let i = 1;
      while (i <= 12) {
        if (i === Number(this.$store.state.querentHouse) ||
            Houseify(i+1) === Number(this.$store.state.querentHouse)) {
          i++;
          continue
        }
        if (i === Number(this.$store.state.quesitedHouse) ||
            Houseify(i+1) === Number(this.$store.state.quesitedHouse)) {
          i++
          continue
        }

        const curFigure = getFigureInHouse(this.$store, i)
        const nextFigure = getFigureInHouse(this.$store, Houseify(i+1))
        if (compare.sameFigure(querentFigure, curFigure) &&
            compare.sameFigure(quesitedFigure, nextFigure)) {
          mutations.push({
            id: i,
            message: `querent in ${this.romanize(i)}, quesited in ${this.romanize(Houseify(i+1))}`
          })
        } 
        else if (compare.sameFigure(quesitedFigure, curFigure) &&
                 compare.sameFigure(querentFigure, nextFigure)) {
          mutations.push({
            id: i,
            message: `quesited in ${this.romanize(i)}, querent in ${this.romanize(Houseify(i+1))}`
          })
        }

        i++
      }

      this.hasMutations = mutations.length > 0
      return mutations
    },
    isTranslationBeforeQuerentBeforeQuesited () {
      const result = isTranslation(this.$store, -1, -1)
      this.translationBeforeQuerentBeforeQuesited = result
      return result
    },
    isTranslationBeforeQuerentAfterQuesited () {
      const result = isTranslation(this.$store, -1, +1)
      this.translationBeforeQuerentAfterQuesited = result
      return result
    },
    isTranslationAfterQuerentBeforeQuesited () {
      const result = isTranslation(this.$store, +1, -1)
      this.translationAfterQuerentBeforeQuesited = result
      return result
    },
    isTranslationAfterQuerentAfterQuesited () {
      const result = isTranslation(this.$store, +1, +1)
      this.translationAfterQuerentAfterQuesited = result
      return result
    }
  }
}
</script>
